module.exports = __webpack_public_path__ + "static/media/iconM1.4dc8d6c9.svg";